import * as i0 from '@angular/core';
import { Injectable, InjectionToken, inject, EventEmitter, Component, Output, ChangeDetectionStrategy, NgModule } from '@angular/core';
import * as i2 from '@spartacus/core';
import { Config, HttpParamsURIEncoder, CommandStrategy, OCC_USER_ID_ANONYMOUS, GlobalMessageType, I18nModule, FeaturesConfigModule, provideDefaultConfig, ConfigModule } from '@spartacus/core';
import * as i1 from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import * as i6 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from '@angular/router';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import * as i5 from '@spartacus/checkout/base/components';
import { CheckoutBillingAddressFormService, CheckoutBillingAddressFormModule, CheckoutPaymentMethodComponent, CheckoutPaymentMethodModule } from '@spartacus/checkout/base/components';
import * as i1$1 from '@spartacus/storefront';
import { LaunchDialogService, LAUNCH_CALLER, ICON_TYPE, DIALOG_TYPE, KeyboardFocusModule, IconModule, SpinnerModule, CardModule } from '@spartacus/storefront';
import { combineLatest, Subscription, of, take as take$1 } from 'rxjs';
import { switchMap, map, take } from 'rxjs/operators';
import * as i4$1 from '@spartacus/cart/base/root';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import * as i2$1 from '@spartacus/checkout/base/core';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function DpPaymentCallbackComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "cx-checkout-billing-address-form");
    i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "button", 4);
    i0.ɵɵlistener("click", function DpPaymentCallbackComponent_ng_container_0_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.back());
    });
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 3)(8, "button", 5);
    i0.ɵɵlistener("click", function DpPaymentCallbackComponent_ng_container_0_Template_button_click_8_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.next());
    });
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 2, "common.back"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 4, "common.continue"), " ");
  }
}
function DpPaymentCallbackComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 7);
    i0.ɵɵelement(4, "cx-spinner");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "dpPaymentForm.callback"));
  }
}
function DpConfirmationDialogComponent_h3_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dpPaymentForm.confirmation.heading"), " ");
  }
}
function DpConfirmationDialogComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dpPaymentForm.confirmation.heading"), " ");
  }
}
function DpPaymentMethodComponent_ng_container_0_ng_container_4_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 7);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function DpPaymentMethodComponent_ng_container_0_ng_container_4_ng_container_1_ng_container_2_div_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16)(1, "div", 17)(2, "cx-card", 18);
    i0.ɵɵlistener("sendCard", function DpPaymentMethodComponent_ng_container_0_ng_container_4_ng_container_1_ng_container_2_div_10_Template_cx_card_sendCard_2_listener() {
      const card_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.selectPaymentMethod(card_r4.paymentMethod));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const card_r4 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("border", true)("fitToContainer", true)("content", card_r4.content);
  }
}
function DpPaymentMethodComponent_ng_container_0_ng_container_4_ng_container_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p", 8);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 9)(5, "div", 10)(6, "button", 11);
    i0.ɵɵlistener("click", function DpPaymentMethodComponent_ng_container_0_ng_container_4_ng_container_1_ng_container_2_Template_button_click_6_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.showNewPaymentForm());
    });
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(9, "div", 12);
    i0.ɵɵtemplate(10, DpPaymentMethodComponent_ng_container_0_ng_container_4_ng_container_1_ng_container_2_div_10_Template, 3, 3, "div", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 14)(12, "div", 10)(13, "button", 11);
    i0.ɵɵlistener("click", function DpPaymentMethodComponent_ng_container_0_ng_container_4_ng_container_1_ng_container_2_Template_button_click_13_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.back());
    });
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "div", 10)(17, "button", 15);
    i0.ɵɵpipe(18, "async");
    i0.ɵɵlistener("click", function DpPaymentMethodComponent_ng_container_0_ng_container_4_ng_container_1_ng_container_2_Template_button_click_17_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.next());
    });
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "cxTranslate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_12_0;
    const cards_r5 = i0.ɵɵnextContext(3).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 6, "paymentForm.choosePaymentMethod"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 8, "paymentForm.addNewPayment"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", cards_r5);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 10, ctx_r1.backBtnText), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", !((tmp_12_0 = i0.ɵɵpipeBind1(18, 12, ctx_r1.selectedMethod$)) == null ? null : tmp_12_0.id));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(20, 14, "common.continue"), " ");
  }
}
function DpPaymentMethodComponent_ng_container_0_ng_container_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DpPaymentMethodComponent_ng_container_0_ng_container_4_ng_container_1_div_1_Template, 2, 3, "div", 6)(2, DpPaymentMethodComponent_ng_container_0_ng_container_4_ng_container_1_ng_container_2_Template, 21, 16, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const newPaymentForm_r6 = i0.ɵɵreference(4);
    const cards_r5 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (cards_r5 == null ? null : cards_r5.length) && !ctx_r1.newPaymentFormManuallyOpened)("ngIfElse", newPaymentForm_r6);
  }
}
function DpPaymentMethodComponent_ng_container_0_ng_container_4_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-dp-payment-form", 19);
    i0.ɵɵlistener("setPaymentDetails", function DpPaymentMethodComponent_ng_container_0_ng_container_4_ng_template_3_Template_cx_dp_payment_form_setPaymentDetails_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setPaymentDetails($event));
    })("closeForm", function DpPaymentMethodComponent_ng_container_0_ng_container_4_ng_template_3_Template_cx_dp_payment_form_closeForm_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.hideNewPaymentForm());
    });
    i0.ɵɵelementEnd();
  }
}
function DpPaymentMethodComponent_ng_container_0_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DpPaymentMethodComponent_ng_container_0_ng_container_4_ng_container_1_Template, 3, 3, "ng-container", 5);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, DpPaymentMethodComponent_ng_container_0_ng_container_4_ng_template_3_Template, 1, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const loading_r8 = i0.ɵɵreference(6);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(2, 2, ctx_r1.isUpdating$))("ngIfElse", loading_r8);
  }
}
function DpPaymentMethodComponent_ng_container_0_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
function DpPaymentMethodComponent_ng_container_0_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-dp-payment-callback", 21);
    i0.ɵɵlistener("paymentDetailsAdded", function DpPaymentMethodComponent_ng_container_0_ng_template_7_Template_cx_dp_payment_callback_paymentDetailsAdded_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.paymentDetailsAdded($event));
    })("closeCallback", function DpPaymentMethodComponent_ng_container_0_ng_template_7_Template_cx_dp_payment_callback_closeCallback_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.hideCallbackScreen());
    });
    i0.ɵɵelementEnd();
  }
}
function DpPaymentMethodComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "h3", 4);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, DpPaymentMethodComponent_ng_container_0_ng_container_4_Template, 5, 4, "ng-container", 5)(5, DpPaymentMethodComponent_ng_container_0_ng_template_5_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(7, DpPaymentMethodComponent_ng_container_0_ng_template_7_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const loadingPaymentDetails_r10 = i0.ɵɵreference(8);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, "paymentForm.payment"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.showCallbackScreen)("ngIfElse", loadingPaymentDetails_r10);
  }
}
const occDigitalPaymentsEndpoints = {
  paymentRequest: 'users/${userId}/carts/${cartId}/payment/digitalPayments/request',
  paymentDetails: 'users/${userId}/carts/${cartId}/payment/digitalPayments/response'
};
const occDigitalPaymentsConfig = {
  backend: {
    occ: {
      endpoints: {
        ...occDigitalPaymentsEndpoints
      }
    }
  }
};
let DigitalPaymentsConfig = /*#__PURE__*/(() => {
  class DigitalPaymentsConfig {
    static {
      this.ɵfac = function DigitalPaymentsConfig_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DigitalPaymentsConfig)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: DigitalPaymentsConfig,
        factory: function DigitalPaymentsConfig_Factory(__ngFactoryType__) {
          let __ngConditionalFactory__ = null;
          if (__ngFactoryType__) {
            __ngConditionalFactory__ = new (__ngFactoryType__ || DigitalPaymentsConfig)();
          } else {
            __ngConditionalFactory__ = i0.ɵɵinject(Config);
          }
          return __ngConditionalFactory__;
        },
        providedIn: 'root'
      });
    }
  }
  return DigitalPaymentsConfig;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const DP_DETAILS_NORMALIZER = new InjectionToken('DpDetailsNormalizer');
const DP_REQUEST_NORMALIZER = new InjectionToken('DpRequestNormalizer');

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class DigitalPaymentsAdapter {}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let OccDpDetailsNormalizer = /*#__PURE__*/(() => {
  class OccDpDetailsNormalizer {
    convert(source, target) {
      if (target === undefined) {
        target = {
          ...source
        };
      }
      return target;
    }
    static {
      this.ɵfac = function OccDpDetailsNormalizer_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OccDpDetailsNormalizer)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: OccDpDetailsNormalizer,
        factory: OccDpDetailsNormalizer.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return OccDpDetailsNormalizer;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let OccDpRequestNormalizer = /*#__PURE__*/(() => {
  class OccDpRequestNormalizer {
    convert(source, target) {
      if (target === undefined) {
        target = {
          ...source
        };
      }
      target.url = source.postUrl;
      target.sessionId = source?.parameters?.entry?.find(it => it.key === 'session_id')?.value;
      target.signature = source?.parameters?.entry?.find(it => it.key === 'signature')?.value;
      return target;
    }
    static {
      this.ɵfac = function OccDpRequestNormalizer_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OccDpRequestNormalizer)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: OccDpRequestNormalizer,
        factory: OccDpRequestNormalizer.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return OccDpRequestNormalizer;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const CURRENT_CART = 'current';
const DP_CARD_REGISTRATION_STATUS = 'x-card-registration-status';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let OccDigitalPaymentsAdapter = /*#__PURE__*/(() => {
  class OccDigitalPaymentsAdapter {
    constructor(http, occEndpoints, converter) {
      this.http = http;
      this.occEndpoints = occEndpoints;
      this.converter = converter;
      this.paramEncoder = new HttpParamsURIEncoder();
      this.config = inject(DigitalPaymentsConfig);
    }
    createPaymentRequest(userId, cartId = CURRENT_CART) {
      const url = this.occEndpoints.buildUrl('paymentRequest', {
        urlParams: {
          userId,
          cartId
        }
      });
      return this.http.post(url, null).pipe(this.converter.pipeable(DP_REQUEST_NORMALIZER));
    }
    createPaymentDetails(sessionId, signature, userId, cartId = CURRENT_CART, billingAddress) {
      const params = this.getDpHttpParams(sessionId, signature, billingAddress);
      const url = this.occEndpoints.buildUrl('paymentDetails', {
        urlParams: {
          userId,
          cartId
        }
      });
      return this.http.post(url, null, {
        params: params
      }).pipe(this.converter.pipeable(DP_DETAILS_NORMALIZER));
    }
    getDpHttpParams(sessionId, signature, billingAddress) {
      let params = new HttpParams({
        encoder: this.paramEncoder
      });
      const paramName = this.config.digitalPayments?.occQueryParams;
      params = this.appendParam(params, paramName?.sessionId, sessionId);
      params = this.appendParam(params, paramName?.signature, signature);
      if (billingAddress && paramName) {
        params = this.appendBillingAddressParams(params, paramName, billingAddress);
      }
      return params;
    }
    appendParam(params, paramName, paramValue) {
      if (paramName && paramValue) {
        params = params.append(paramName, paramValue);
      }
      return params;
    }
    appendBillingAddressParams(params, paramName, billingAddress) {
      params = this.appendParam(params, paramName.billingAddress, 'true');
      params = this.appendParam(params, paramName.country, billingAddress.country?.isocode);
      params = this.appendParam(params, paramName.firstName, billingAddress.firstName);
      params = this.appendParam(params, paramName.lastName, billingAddress.lastName);
      params = this.appendParam(params, paramName.line1, billingAddress.line1);
      params = this.appendParam(params, paramName.line2, billingAddress.line2);
      params = this.appendParam(params, paramName.town, billingAddress.town);
      params = this.appendParam(params, paramName.region, billingAddress.region?.isocodeShort);
      params = this.appendParam(params, paramName.postalCode, billingAddress.postalCode);
      return params;
    }
    static {
      this.ɵfac = function OccDigitalPaymentsAdapter_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OccDigitalPaymentsAdapter)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.OccEndpointsService), i0.ɵɵinject(i2.ConverterService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: OccDigitalPaymentsAdapter,
        factory: OccDigitalPaymentsAdapter.ɵfac
      });
    }
  }
  return OccDigitalPaymentsAdapter;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultDigitalPaymentsConfig = {
  digitalPayments: {
    occQueryParams: {
      sessionId: 'sid',
      signature: 'sign',
      billingAddress: 'billingAddress',
      country: 'country',
      firstName: 'firstName',
      lastName: 'lastName',
      line1: 'line1',
      line2: 'line2',
      town: 'town',
      region: 'region',
      postalCode: 'postalCode'
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let DpCheckoutPaymentService = /*#__PURE__*/(() => {
  class DpCheckoutPaymentService {
    constructor(dpAdapter, command, query, userIdService) {
      this.dpAdapter = dpAdapter;
      this.command = command;
      this.query = query;
      this.userIdService = userIdService;
      this.activeCartFacade = inject(ActiveCartFacade);
      this.RequestUrlQuery = this.query.create(() => {
        return this.checkoutPreconditions().pipe(switchMap(([userId, cartId]) => this.dpAdapter.createPaymentRequest(userId, cartId)));
      });
      this.createPaymentDetailsCommand = this.command.create(payload => this.checkoutPreconditions().pipe(switchMap(([userId, cartId]) => {
        return this.dpAdapter.createPaymentDetails(payload.sessionId, payload.signature, userId, cartId, payload?.billingAddress);
      })), {
        strategy: CommandStrategy.Queue
      });
    }
    getCardRegistrationDetails() {
      return this.RequestUrlQuery.getState().pipe(map(state => {
        if (state.loading === false && state.error !== false) {
          throw new Error(state.error.message);
        } else {
          return state.data;
        }
      }));
    }
    createPaymentDetails(sessionId, signature, billingAddress) {
      return this.createPaymentDetailsCommand.execute({
        sessionId,
        signature,
        billingAddress
      });
    }
    /**
     * Performs the necessary checkout preconditions.
     */
    checkoutPreconditions() {
      return combineLatest([this.userIdService.takeUserId(), this.activeCartFacade.takeActiveCartId(), this.activeCartFacade.isGuestCart()]).pipe(take(1), map(([userId, cartId, isGuestCart]) => {
        if (!userId || !cartId || userId === OCC_USER_ID_ANONYMOUS && !isGuestCart) {
          throw new Error('Checkout conditions not met');
        }
        return [userId, cartId];
      }));
    }
    static {
      this.ɵfac = function DpCheckoutPaymentService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DpCheckoutPaymentService)(i0.ɵɵinject(DigitalPaymentsAdapter), i0.ɵɵinject(i2.CommandService), i0.ɵɵinject(i2.QueryService), i0.ɵɵinject(i2.UserIdService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: DpCheckoutPaymentService,
        factory: DpCheckoutPaymentService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return DpCheckoutPaymentService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const KEY = 'digital-payment.checkout.request';
let DpLocalStorageService = /*#__PURE__*/(() => {
  class DpLocalStorageService {
    constructor(statePersistenceService) {
      this.statePersistenceService = statePersistenceService;
      this.subscription = new Subscription();
    }
    syncCardRegistrationState(request) {
      this.subscription.add(this.statePersistenceService.syncWithStorage({
        key: KEY,
        state$: of(request)
      }));
    }
    readCardRegistrationState() {
      const paymentRequest = this.statePersistenceService.readStateFromStorage({
        key: KEY
      });
      this.clearDpStorage();
      return paymentRequest;
    }
    clearDpStorage() {
      this.statePersistenceService.syncWithStorage({
        key: KEY,
        state$: of({})
      });
    }
    ngOnDestroy() {
      this.subscription.unsubscribe();
    }
    static {
      this.ɵfac = function DpLocalStorageService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DpLocalStorageService)(i0.ɵɵinject(i2.StatePersistenceService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: DpLocalStorageService,
        factory: DpLocalStorageService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return DpLocalStorageService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DpPaymentCallbackComponent = /*#__PURE__*/(() => {
  class DpPaymentCallbackComponent {
    constructor(dpPaymentService, dpStorageService, globalMsgService, route) {
      this.dpPaymentService = dpPaymentService;
      this.dpStorageService = dpStorageService;
      this.globalMsgService = globalMsgService;
      this.route = route;
      this.closeCallback = new EventEmitter();
      this.paymentDetailsAdded = new EventEmitter();
      this.billingAddressService = inject(CheckoutBillingAddressFormService);
      this.launchDialogService = inject(LaunchDialogService);
      this.showBillingAddressForm = false;
    }
    ngOnInit() {
      const dpResponse = this.route.snapshot.queryParamMap.get(DP_CARD_REGISTRATION_STATUS);
      if (dpResponse?.toLowerCase() === 'successful') {
        this.showBillingAddressForm = true;
      } else {
        this.globalMsgService.add({
          key: 'dpPaymentForm.cancelledOrFailed'
        }, GlobalMessageType.MSG_TYPE_WARNING);
        this.closeCallback.emit();
      }
    }
    back() {
      const dialog = this.launchDialogService.openDialog(LAUNCH_CALLER.DP_SHOW_CONFIRMATION_DIALOG, undefined, undefined);
      if (dialog) {
        dialog.pipe(take$1(1)).subscribe(result => {
          if (result.instance.cardSaveCancelled === true) {
            this.globalMsgService.add({
              key: 'dpPaymentForm.cancelledOrFailed'
            }, GlobalMessageType.MSG_TYPE_WARNING);
            this.closeCallback.emit();
          }
        });
      }
    }
    next() {
      if (this.billingAddressService.isBillingAddressSameAsDeliveryAddress() || this.billingAddressService.isBillingAddressFormValid()) {
        const billingAddress = this.billingAddressService.getBillingAddress();
        this.fetchPaymentDetails(billingAddress);
      } else {
        this.billingAddressService.markAllAsTouched();
      }
    }
    fetchPaymentDetails(billingAddress) {
      const paymentRequest = this.dpStorageService.readCardRegistrationState();
      if (paymentRequest?.sessionId && paymentRequest?.signature) {
        this.dpPaymentService.createPaymentDetails(paymentRequest.sessionId, paymentRequest.signature, billingAddress).subscribe(details => {
          if (details?.id) {
            this.paymentDetailsAdded.emit(details);
          } else if (details) {
            this.globalMsgService.add({
              key: 'dpPaymentForm.error.paymentFetch'
            }, GlobalMessageType.MSG_TYPE_ERROR);
            this.closeCallback.emit();
          }
        });
      } else {
        this.globalMsgService.add({
          key: 'dpPaymentForm.error.unknown'
        }, GlobalMessageType.MSG_TYPE_ERROR);
        this.closeCallback.emit();
      }
    }
    static {
      this.ɵfac = function DpPaymentCallbackComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DpPaymentCallbackComponent)(i0.ɵɵdirectiveInject(DpCheckoutPaymentService), i0.ɵɵdirectiveInject(DpLocalStorageService), i0.ɵɵdirectiveInject(i2.GlobalMessageService), i0.ɵɵdirectiveInject(i4.ActivatedRoute));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DpPaymentCallbackComponent,
        selectors: [["cx-dp-payment-callback"]],
        outputs: {
          closeCallback: "closeCallback",
          paymentDetailsAdded: "paymentDetailsAdded"
        },
        standalone: false,
        decls: 3,
        vars: 2,
        consts: [["showSpinner", ""], [4, "ngIf", "ngIfElse"], [1, "cx-checkout-btns", "row"], [1, "col-md-12", "col-lg-6"], [1, "btn", "btn-block", "btn-secondary", 3, "click"], [1, "btn", "btn-block", "btn-primary", 3, "click"], [1, "text-center"], [1, "cx-spinner"]],
        template: function DpPaymentCallbackComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, DpPaymentCallbackComponent_ng_container_0_Template, 11, 6, "ng-container", 1)(1, DpPaymentCallbackComponent_ng_template_1_Template, 5, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const showSpinner_r3 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.showBillingAddressForm)("ngIfElse", showSpinner_r3);
          }
        },
        dependencies: [i6.NgIf, i1$1.SpinnerComponent, i5.CheckoutBillingAddressFormComponent, i2.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return DpPaymentCallbackComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let DpConfirmationDialogComponent = /*#__PURE__*/(() => {
  class DpConfirmationDialogComponent {
    constructor() {
      this.focusConfig = {
        trap: true,
        block: true,
        autofocus: 'button',
        focusOnEscape: true
      };
      this.iconTypes = ICON_TYPE;
      this.launchDialogService = inject(LaunchDialogService);
      this.activatedRoute = inject(ActivatedRoute);
      this.router = inject(Router);
      this.cardSaveCancelled = false;
    }
    dismissDialog(reason) {
      this.launchDialogService.closeDialog(reason);
    }
    continue() {
      const queryParams = {
        ...this.activatedRoute.snapshot.queryParams
      };
      delete queryParams[DP_CARD_REGISTRATION_STATUS];
      this.router.navigate([], {
        queryParams,
        relativeTo: this.activatedRoute
      });
      this.cardSaveCancelled = true;
      this.launchDialogService.closeDialog('continue clicked');
    }
    static {
      this.ɵfac = function DpConfirmationDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DpConfirmationDialogComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DpConfirmationDialogComponent,
        selectors: [["cx-dp-confirmation-dialog"]],
        standalone: false,
        decls: 22,
        vars: 19,
        consts: [["role", "dialog", "aria-modal", "true", "aria-labelledby", "dialogTitle", 1, "cx-modal-container", 3, "esc", "cxFocus"], [1, "cx-modal-content"], [1, "cx-dialog-header", "modal-header"], ["id", "dialogTitle", "class", "cx-dialog-title modal-title", 4, "cxFeature"], ["type", "button", 1, "close", 3, "click", "title"], ["aria-hidden", "true"], [3, "type"], [1, "cx-dialog-body", "modal-body"], [1, "cx-dialog-row"], [1, "cx-dialog-actions", "col-sm-12", "col-md-6"], [1, "cx-dialog-buttons"], ["autofocus", "", 1, "btn", "btn-primary", 3, "click"], ["autofocus", "", 1, "link", "cx-action-link", 3, "click"], ["id", "dialogTitle", 1, "cx-dialog-title", "modal-title"]],
        template: function DpConfirmationDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("esc", function DpConfirmationDialogComponent_Template_div_esc_0_listener() {
              return ctx.dismissDialog("Escape clicked");
            });
            i0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
            i0.ɵɵtemplate(3, DpConfirmationDialogComponent_h3_3_Template, 3, 3, "h3", 3)(4, DpConfirmationDialogComponent_div_4_Template, 3, 3, "div", 3);
            i0.ɵɵelementStart(5, "button", 4);
            i0.ɵɵpipe(6, "cxTranslate");
            i0.ɵɵpipe(7, "cxTranslate");
            i0.ɵɵlistener("click", function DpConfirmationDialogComponent_Template_button_click_5_listener() {
              return ctx.dismissDialog("Cross click");
            });
            i0.ɵɵelementStart(8, "span", 5);
            i0.ɵɵelement(9, "cx-icon", 6);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(10, "div", 7)(11, "div", 8);
            i0.ɵɵtext(12);
            i0.ɵɵpipe(13, "cxTranslate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(14, "div", 9)(15, "div", 10)(16, "button", 11);
            i0.ɵɵlistener("click", function DpConfirmationDialogComponent_Template_button_click_16_listener() {
              return ctx.continue();
            });
            i0.ɵɵtext(17);
            i0.ɵɵpipe(18, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(19, "button", 12);
            i0.ɵɵlistener("click", function DpConfirmationDialogComponent_Template_button_click_19_listener() {
              return ctx.dismissDialog("cancel clicked");
            });
            i0.ɵɵtext(20);
            i0.ɵɵpipe(21, "cxTranslate");
            i0.ɵɵelementEnd()()()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("cxFocus", ctx.focusConfig);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("cxFeature", "a11yDialogsHeading");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!a11yDialogsHeading");
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(6, 9, "common.close"));
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(7, 11, "common.close"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("type", ctx.iconTypes.CLOSE);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 13, "dpPaymentForm.confirmation.text"), " ");
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(18, 15, "common.continue"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(21, 17, "common.cancel"), " ");
          }
        },
        dependencies: [i1$1.FocusDirective, i1$1.IconComponent, i2.FeatureDirective, i2.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return DpConfirmationDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultDpConfirmationDialogConfig = {
  launch: {
    DP_SHOW_CONFIRMATION_DIALOG: {
      inlineRoot: true,
      component: DpConfirmationDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let DpConfirmationDialogModule = /*#__PURE__*/(() => {
  class DpConfirmationDialogModule {
    static {
      this.ɵfac = function DpConfirmationDialogModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DpConfirmationDialogModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: DpConfirmationDialogModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig(defaultDpConfirmationDialogConfig)],
        imports: [CommonModule, I18nModule, KeyboardFocusModule, IconModule, FeaturesConfigModule]
      });
    }
  }
  return DpConfirmationDialogModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let DpPaymentCallbackModule = /*#__PURE__*/(() => {
  class DpPaymentCallbackModule {
    static {
      this.ɵfac = function DpPaymentCallbackModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DpPaymentCallbackModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: DpPaymentCallbackModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, SpinnerModule, I18nModule, CheckoutBillingAddressFormModule, FeaturesConfigModule, DpConfirmationDialogModule]
      });
    }
  }
  return DpPaymentCallbackModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DpPaymentFormComponent = /*#__PURE__*/(() => {
  class DpPaymentFormComponent {
    constructor(dpPaymentService, dpStorageService, globalMsgService, winRef) {
      this.dpPaymentService = dpPaymentService;
      this.dpStorageService = dpStorageService;
      this.globalMsgService = globalMsgService;
      this.winRef = winRef;
      this.closeForm = new EventEmitter();
    }
    ngOnInit() {
      this.dpPaymentService.getCardRegistrationDetails().subscribe(dpPaymentRequest => {
        if (dpPaymentRequest?.url) {
          this.dpStorageService.syncCardRegistrationState(dpPaymentRequest);
          this.redirect(dpPaymentRequest.url);
        } else if (dpPaymentRequest) {
          this.globalMsgService.add({
            key: 'dpPaymentForm.error.redirect'
          }, GlobalMessageType.MSG_TYPE_ERROR);
          this.closeForm.emit();
        }
      });
    }
    redirect(url) {
      const window = this.winRef.nativeWindow;
      if (window?.location) {
        window.location.href = url;
      }
    }
    static {
      this.ɵfac = function DpPaymentFormComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DpPaymentFormComponent)(i0.ɵɵdirectiveInject(DpCheckoutPaymentService), i0.ɵɵdirectiveInject(DpLocalStorageService), i0.ɵɵdirectiveInject(i2.GlobalMessageService), i0.ɵɵdirectiveInject(i2.WindowRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DpPaymentFormComponent,
        selectors: [["cx-dp-payment-form"]],
        outputs: {
          closeForm: "closeForm"
        },
        standalone: false,
        decls: 5,
        vars: 3,
        consts: [[1, "text-center"], [1, "cx-spinner"]],
        template: function DpPaymentFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtext(1);
            i0.ɵɵpipe(2, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 1);
            i0.ɵɵelement(4, "cx-spinner");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "dpPaymentForm.redirect"));
          }
        },
        dependencies: [i1$1.SpinnerComponent, i2.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return DpPaymentFormComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let DpPaymentFormModule = /*#__PURE__*/(() => {
  class DpPaymentFormModule {
    static {
      this.ɵfac = function DpPaymentFormModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DpPaymentFormModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: DpPaymentFormModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, ReactiveFormsModule, NgSelectModule, I18nModule, SpinnerModule]
      });
    }
  }
  return DpPaymentFormModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let DpPaymentMethodComponent = /*#__PURE__*/(() => {
  class DpPaymentMethodComponent extends CheckoutPaymentMethodComponent {
    isDpCallback() {
      const queryParams = this.activatedRoute.snapshot.queryParamMap.get(DP_CARD_REGISTRATION_STATUS);
      return !!queryParams;
    }
    hideCallbackScreen() {
      this.showCallbackScreen = false;
    }
    paymentDetailsAdded(paymentDetails) {
      this.savePaymentMethod(paymentDetails);
    }
    onSuccess() {
      super.onSuccess();
      this.next();
    }
    // TODO:#checkout - handle breaking changes
    constructor(userPaymentService, checkoutDeliveryAddressFacade, checkoutPaymentFacade, activatedRoute, translationService, activeCartFacade, checkoutStepService, globalMessageService) {
      super(userPaymentService, checkoutDeliveryAddressFacade, checkoutPaymentFacade, activatedRoute, translationService, activeCartFacade, checkoutStepService, globalMessageService);
      this.userPaymentService = userPaymentService;
      this.checkoutDeliveryAddressFacade = checkoutDeliveryAddressFacade;
      this.checkoutPaymentFacade = checkoutPaymentFacade;
      this.activatedRoute = activatedRoute;
      this.translationService = translationService;
      this.activeCartFacade = activeCartFacade;
      this.checkoutStepService = checkoutStepService;
      this.globalMessageService = globalMessageService;
      this.showCallbackScreen = false;
      this.showCallbackScreen = this.isDpCallback();
    }
    static {
      this.ɵfac = function DpPaymentMethodComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DpPaymentMethodComponent)(i0.ɵɵdirectiveInject(i2.UserPaymentService), i0.ɵɵdirectiveInject(i2$1.CheckoutDeliveryAddressService), i0.ɵɵdirectiveInject(i2$1.CheckoutPaymentService), i0.ɵɵdirectiveInject(i4.ActivatedRoute), i0.ɵɵdirectiveInject(i2.TranslationService), i0.ɵɵdirectiveInject(i4$1.ActiveCartFacade), i0.ɵɵdirectiveInject(i5.CheckoutStepService), i0.ɵɵdirectiveInject(i2.GlobalMessageService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DpPaymentMethodComponent,
        selectors: [["cx-payment-method"]],
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 2,
        vars: 3,
        consts: [["loading", ""], ["loadingPaymentDetails", ""], ["newPaymentForm", ""], [4, "ngIf"], [1, "cx-checkout-title", "d-none", "d-lg-block", "d-xl-block"], [4, "ngIf", "ngIfElse"], ["role", "status", 4, "cxFeature"], ["role", "status"], [1, "cx-checkout-text"], [1, "cx-checkout-btns", "row"], [1, "col-md-12", "col-lg-6"], [1, "btn", "btn-block", "btn-secondary", 3, "click"], [1, "cx-checkout-body", "row"], ["class", "cx-payment-card col-md-12 col-lg-6", 4, "ngFor", "ngForOf"], [1, "row", "cx-checkout-btns"], [1, "btn", "btn-block", "btn-primary", 3, "click", "disabled"], [1, "cx-payment-card", "col-md-12", "col-lg-6"], [1, "cx-payment-card-inner"], [3, "sendCard", "border", "fitToContainer", "content"], [3, "setPaymentDetails", "closeForm"], [1, "cx-spinner"], [3, "paymentDetailsAdded", "closeCallback"]],
        template: function DpPaymentMethodComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, DpPaymentMethodComponent_ng_container_0_Template, 9, 5, "ng-container", 3);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.cards$));
          }
        },
        dependencies: [i6.NgForOf, i6.NgIf, DpPaymentFormComponent, i1$1.CardComponent, i1$1.SpinnerComponent, DpPaymentCallbackComponent, i2.FeatureDirective, i6.AsyncPipe, i2.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return DpPaymentMethodComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let DpPaymentMethodModule = /*#__PURE__*/(() => {
  class DpPaymentMethodModule extends CheckoutPaymentMethodModule {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵDpPaymentMethodModule_BaseFactory;
        return function DpPaymentMethodModule_Factory(__ngFactoryType__) {
          return (ɵDpPaymentMethodModule_BaseFactory || (ɵDpPaymentMethodModule_BaseFactory = i0.ɵɵgetInheritedFactory(DpPaymentMethodModule)))(__ngFactoryType__ || DpPaymentMethodModule);
        };
      })();
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: DpPaymentMethodModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig(defaultDigitalPaymentsConfig)],
        imports: [CommonModule, DpPaymentFormModule, RouterModule, CardModule, SpinnerModule, I18nModule, DpPaymentCallbackModule, ConfigModule.withConfig({
          cmsComponents: {
            CheckoutPaymentDetails: {
              component: DpPaymentMethodComponent
            }
          }
        }), FeaturesConfigModule]
      });
    }
  }
  return DpPaymentMethodModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let DpCheckoutModule = /*#__PURE__*/(() => {
  class DpCheckoutModule {
    static {
      this.ɵfac = function DpCheckoutModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DpCheckoutModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: DpCheckoutModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [{
          provide: DigitalPaymentsAdapter,
          useClass: OccDigitalPaymentsAdapter
        }, {
          provide: DP_DETAILS_NORMALIZER,
          useExisting: OccDpDetailsNormalizer,
          multi: true
        }, {
          provide: DP_REQUEST_NORMALIZER,
          useExisting: OccDpRequestNormalizer,
          multi: true
        }, DpCheckoutPaymentService, provideDefaultConfig(occDigitalPaymentsConfig)],
        imports: [DpPaymentMethodModule]
      });
    }
  }
  return DpCheckoutModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let DigitalPaymentsModule = /*#__PURE__*/(() => {
  class DigitalPaymentsModule {
    static {
      this.ɵfac = function DigitalPaymentsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DigitalPaymentsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: DigitalPaymentsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [DpCheckoutModule]
      });
    }
  }
  return DigitalPaymentsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/*
 * Public API Surface for Digital-Payments
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DigitalPaymentsModule, DpCheckoutModule, DpCheckoutPaymentService };
